import {COMMON} from 'Constants/ActionTypes';

const actions = {
  optError(data) {
    return {
      type: COMMON.OPT_ERROR,
      data,
    };
  },
  toggleSider(data) {
    return {
      type: COMMON.TOGGLE_SIDER,
      data,
    };
  },
  setSpa(data){
    return {
      type: COMMON.SET_SPA,
      data
    }
  },
  // 获取项目进度
  getTaskProgress() {
    return {
      type: COMMON.GET_TASK_PROGRESS,
      payload: {
        request: {
          method: 'get',
          url: '/robot/task/progress',
        },
      },
    };
  },
  // 获取菜单
  getSideNav() {
    return {
      type: COMMON.GET_SIDE_NAV,
      payload: {
        request: {
          method: 'get',
          url: '/robot/permit/route',
        },
      },
    };
  },
};

export default actions;
